import React from "react";
import {
    Modal,
    ModalProps,
} from "@evidenceb/athena-common/design-system/Modal";
import { Playlist, PlaylistItem, PlaylistStatus } from "../../../../../type";
import { defineMessages, useIntl } from "react-intl";
import { fullName } from "../../../../../../../../utils/format";
import PlaylistCard, { minimalOptions } from "../../PlaylistCard/PlaylistCard";
import PlaylistItemsList from "./PlaylistItemsList";
import { UserAvatar } from "../../../../../../../../components/Avatar/Avatar";
import { Student } from "../../../../../../../../interfaces/Session";
import {
    useGetPlaylistAnswers,
    usePlaylistProgressQuery,
} from "../../../../../api/useQueries";

import "./ProgressionModal.scss";

type Props = Pick<ModalProps, "open" | "onClose"> & {
    playlist: Playlist<PlaylistItem>;
    student: Student;
};

const ProgressionModal = ({ open, onClose, playlist, student }: Props) => {
    const { data: progress } = usePlaylistProgressQuery(
        playlist.learning_set_id
    );

    const answers = useGetPlaylistAnswers(playlist.learning_set_id, student.id);

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={<ProgressionModalHeader student={student} />}
            disableFooter
            className="progression-modal"
            aria-labelledby="progression-modal-title"
        >
            <PlaylistCard
                status={PlaylistStatus.SENT}
                playlist={{
                    ...playlist,
                    progress,
                }}
                opts={{ ...minimalOptions, absoluteProgress: true }}
                studentId={student.id}
                className="progression-modal__playlist-card"
            />

            <PlaylistItemsList
                playlist={playlist}
                answers={answers}
                studentId={student.id}
            />
        </Modal>
    );
};
export default ProgressionModal;

const ProgressionModalHeader = ({ student }: Pick<Props, "student">) => {
    const intl = useIntl();

    return (
        <div className="progression-modal__header">
            <UserAvatar user={student} />
            <h2 id="progression-modal-title">
                {intl.formatMessage(messages.progressOf, {
                    studentName: fullName(student, {
                        capitalizeLastName: true,
                    }),
                })}
            </h2>
        </div>
    );
};

const messages = defineMessages({
    progressOf: {
        id: "playlist-progressionModal-progressOf",
        defaultMessage: "{studentName}'s progress",
    },
});
